/**
 * Gets PrintProductConfiguration for PrintProduct CustomPrint checkout.
 *
 * @param {Object} card The card.
 * @returns {undefined|{print_product_id, print_product_size_id}}
 */
export const getCardPrintProductConfiguration = card => {
  if (!card) {
    return undefined;
  }

  const cardTemplate =
    card.card_side_groups.records[0].card_sides.records[0].card_template;
  const printProduct = cardTemplate.print_product;
  const sizes = printProduct?.sizes?.records ?? [];
  const printSize = cardTemplate.print_size;
  const printProductSize = printSize
    ? sizes.find(productSize => productSize.print_size?.id === printSize.id) ??
      sizes?.[0]
    : sizes?.[0];

  if (!printProduct) {
    return undefined;
  }

  return {
    print_product_id: printProduct.id,
    print_product_size_id: printProductSize.id,
  };
};
